/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{max as t}from"../../core/quantityUtils.js";import{autoDistance2D as e}from"./automaticLengthMeasurementUtils.js";function o({topLeft:o,topRight:n,bottomRight:i,bottomLeft:r,spatialReference:l}){const u=t(e(r,i,l),e(o,n,l));if(null==u)return null;const m=t(e(i,n,l),e(r,o,l));return null==m?null:{xSize:u,ySize:m}}export{o as autoSize2D};
